module.exports = __webpack_public_path__ + "media/images/athletes/146-ea699017d72df0de8f12a9e98a0d8b5d.png";